/// <amd-module name="Core/Medius.Core.Web/Scripts/Bifrost/communication"/>

export function notifyOnLoad(){
    window.parent.postMessage({ version: 1, origin: "Midgard", type: "loaded", data: {
        application: "APA"
    } }, '*');
}

export function notifyOnHashChange(event: any) {
    window.parent.postMessage({ version: 1, origin: "Midgard", type: "hashchange", data: {
        url: event.newURL
    } }, '*');

    const urlMappings = [
        // route admin pages only to legacyInbox after admin pages AP fix
        { pattern: "SupplierInvoicesInboxLegacy#/Administration", app: "MidgardManagement" },
        { pattern: "SupplierInvoicesInbox#/Administration", app: "MidgardManagement" },
        { pattern: "SupplierInvoicesInboxLegacy#/configuration", app: "MidgardManagement" },
        { pattern: "SupplierInvoicesInbox#/configuration", app: "MidgardManagement" },
        { pattern: "SupplierInvoicesInboxLegacy#/Reports", app: "MidgardReporting" },
        { pattern: "SupplierInvoicesInbox#/Reports", app: "MidgardReporting" },
        { pattern: "SupplierInvoicesInboxLegacy#/Dashboard", app: "MidgardDashboard" },
        { pattern: "SupplierInvoicesInbox#/Dashboard", app: "MidgardDashboard" },
        { pattern: "SupplierInvoicesInboxLegacy#/DocumentCreate/Create", app: "MidgardCreateDocumentLegacy" },
        { pattern: "SupplierInvoicesInbox#/DocumentCreate/Create", app: "MidgardCreateDocument" },
        { pattern: "SupplierInvoicesInbox#/Tasks", app: "MidgardInbox" },
        { pattern: "SupplierInvoicesInboxLegacy#/ArchiveSearch", app: "MidgardLongTermArchive" },
        { pattern: "SupplierInvoicesInboxLegacy#", app: "MidgardInboxLegacy"}
    ];

    function shouldChangeBifrostUrl(newUrl: string, oldUrl: string): boolean {
        try {
            const base = window.location.origin;
            const oldUrlObj = new URL(oldUrl, base);
            const newUrlObj = new URL(newUrl, base);
            return oldUrlObj.pathname !== newUrlObj.pathname || oldUrlObj.hash !== newUrlObj.hash;
        } catch (e) {
            return false;
        }
    }

    function getDeepLink(url: string): string {
        for (const mapping of urlMappings) {
            if (url.includes(mapping.pattern)) {
            const patternIndex = url.indexOf(mapping.pattern);
            const afterPattern = url.substring(patternIndex + mapping.pattern.length);
            return afterPattern || "";
            }
        }
        return "";
    }

    function getTargetApp(url: string): string {
        const match = urlMappings.find(mapping => url.includes(mapping.pattern));
        return match ? match.app : "";
    }

    if (shouldChangeBifrostUrl(event.newURL, event.oldURL)) {
        const targetApp = getTargetApp(event.newURL);        
        const deepLink = getDeepLink(event.newURL);
        notifyNavigateTo(event.oldURL, targetApp, deepLink, event.newURL);
    }
        
}

export function notifyVersion(version: string) {
    window.parent.postMessage({ version: 1, origin: "Midgard", type: "version", data: {
        version
    } }, '*');
}

export function notifyExportsChange(exportData: any) {
    window.parent.postMessage({ version: 1, origin: "Midgard", type: "exportchange", data: {
        exports: exportData
    } }, '*');
}

export function notifyExportsModalShown() {
    window.parent.postMessage({ version: 1, origin: "Midgard", type: "exports-modal-shown", data: {} }, '*');
}

export function notifyShowNotification(kind: 'success' | 'info' | 'error', title?: string | null, message?: string | null) {
    window.parent.postMessage({ version: 1, origin: "Midgard", type: "notification-shown", data: {
        kind,
        title: title || null,
        message: message || null
    } }, '*');
}

export function notifyNavigateTo(currentUrl: string, targetApp: string, deepLink: string, newURL: string) {
    window.parent.postMessage({ version: 1, origin: "Midgard", type: "navigate-to", data: {
        "currentUrl": currentUrl,
        "targetUrl": newURL,
        "targetApp": targetApp,                
        "deepLink": deepLink
    } }, '*');
}
